// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__1m44e","white":"Card_white__1yFnn","blue":"Card_blue__1ugvn","alt":"Card_alt__J9sV7"};